var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('el-dialog',{attrs:{"title":"扫码登录","visible":_vm.show,"width":"593px"},on:{"update:visible":function($event){_vm.show=$event}}},[_c('div',{staticClass:"dialogContent"},[_c('img',{attrs:{"src":_vm.codeImg,"alt":""}}),_c('span',{staticClass:"font-20"},[_vm._v("请使用微信扫描二维码登录")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }